<template>
  <modal id="editPtStop"
         :show="showModal"
         modal-classes="modal-dialog-centered modal-lg"
         showClose
         @close="close"
  >
    <template slot="header">
      <h4 class="modal-title">
        {{ $t('ptStops.edit.titleText') }}
      </h4>
    </template>
    <template>
      <div class="text-center text-muted mb-2">
        <small>{{ $t('ptStops.edit.helpText') }}</small>
      </div>

      <base-alert v-if="alert" dismissible :dismiss-callback="() => alert=false" type="danger">
        <!-- TODO: add error translation -->
        {{ getActionErrorDetails }}
      </base-alert>

      <form role="form" @submit.prevent="validate()">
        <div class="row">
          <label class="col-sm-3 col-form-label">{{ $t('ptStops.details.stop_id') }}</label>
          <div class="col-md-9">
            <base-input
              data-vv-as="'stop_id'"
              name="stop_id"
              v-validate="modelValidations.required"
              :error="getError('stop_id')"
              v-model="formDetails.stop_id">
            </base-input>
          </div>
        </div>

        <div class="row">
          <label class="col-sm-3 col-form-label">{{ $t('ptStops.details.name') }}</label>
          <div class="col-md-9">
            <base-input
              data-vv-as="'name'"
              name="name"
              v-validate="modelValidations.required"
              :error="getError('name')"
              v-model="formDetails.name">
            </base-input>
          </div>
        </div>

        <div class="row">
          <label class="col-sm-3 col-form-label">{{ $t('ptStops.details.zone_id') }}</label>
          <div class="col form-group">
            <el-select
              class="select-primary"
              name="zone_id"
              v-model="formDetails.zone_id"
            >
              <el-option
                v-for="option in ptZones"
                class="select-primary"
                :value="option.id"
                :label="option.id"
                :key="option.id"
              >
              </el-option>
            </el-select>
          </div>
        </div>

        <div class="row">
          <label class="col-sm-3 col-form-label">{{ $t('ptStops.details.municipality_id') }}</label>
          <div class="col form-group">
            <el-select
              class="select-primary"
              name="zone_id"
              v-model="formDetails.municipality_id"
            >
              <el-option
                v-for="option in municipalities"
                class="select-primary"
                :value="option.id"
                :label="option.id"
                :key="option.id"
              >
              </el-option>
            </el-select>
          </div>
        </div>

        <div class="row">
          <label class="col-sm-3 col-form-label">{{ $t('ptStops.details.pavilion') }}</label>
          <div class="col-sm-9">
            <base-checkbox
              inline
              v-model="formDetails.info.pavilion"
            ></base-checkbox>
          </div>
        </div>
        <div class="row">
          <label class="col-sm-3 col-form-label">{{ $t('ptStops.details.voice_tag') }}</label>
          <div class="col-sm-9">
            <base-checkbox
              inline
              v-model="formDetails.info.voice_tag"
            ></base-checkbox>
          </div>
        </div>
        <div class="row">
          <label class="col-sm-3 col-form-label">{{ $t('ptStops.details.digital_display') }}</label>
          <div class="col-sm-9">
            <base-checkbox
              inline
              v-model="formDetails.info.digital_display"
            ></base-checkbox>
          </div>
        </div>
        <div class="row">
          <label class="col-sm-3 col-form-label">{{ $t('ptStops.details.paper_schedule') }}</label>
          <div class="col-sm-9">
            <base-checkbox
              inline
              v-model="formDetails.info.paper_schedule"
            ></base-checkbox>
          </div>
        </div>
        <div class="row">
          <label class="col-sm-3 col-form-label">{{ $t('ptStops.details.metadata') }}</label>
          <div class="col-md-9">
            <base-input
              data-vv-as="'metadataKeyVal'"
              name="metadataKeyVal"
              v-validate="modelValidations.validMetadata"
              :error="getError('metadataKeyVal')"
              v-model="formDetails.info.metadataKeyVal">
            </base-input>
          </div>
        </div>
        <div class="text-center">
          <base-button
            type="info"
            :loading="updating"
            class="my-4"
            native-type="submit"
          >{{ $t('ptStops.edit.actionBtnLabel') }}
          </base-button>
        </div>
      </form>
    </template>
  </modal>
</template>


<script>
import {BaseAlert, Modal} from 'src/components';
import {Option, Select} from 'element-ui';
import {mapActions, mapState} from "vuex";

export default {
  name: 'edit-pt-stop-dialog',
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    Modal,
    BaseAlert
  },
  props: {
    formDetails: {
      type: Object,
      required: true
    },
    show: {
      type: Boolean,
      required: true
    },
    ptZones: {
      type: Array,
      required: true,
    },
    municipalities: {
      type: Array,
      required: true,
    }
  },
  data() {
    return {
      alert: false,
      modelValidations: {
        required: {
          required: true
        },
        validMetadata: {
          metadataObj: true
        },
      }
    }
  },
  computed: {
    ...mapState({
      updating: state => state.pt_stop.updating,
      error: state => state.pt_stop.error,
    }),
    getActionErrorDetails() {
      return this.error ? this.error.bodyText : null;
    },
    showModal() {
      return this.show == true
    },
    metadata() {
      return JSON.stringfy(this.props.formDetails)
    }
  },
  methods: {
    ...mapActions(['UpdatePtStop']),
    close: function () {
      this.$emit('close');
    },
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate() {
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.update()
        }
      });
    },
    update: function () {
      try {
        let metadataObj = JSON.parse(this.formDetails.info.metadataKeyVal)
        this.formDetails.info["metadata"] = metadataObj;
      } catch (e) {
        console.log("failed parse ", this.formDetails.info.metadataKeyVal, e)
      }

      this.UpdatePtStop(this.formDetails).then(() => {
        if (this.error != null) {
          this.alert = true
        } else {
          this.$notify({
            type: 'success',
            message: this.$t('ptStops.edit.updatedNotification', this.formDetails),
            icon: 'tim-icons icon-alert-circle-exc'
          })
          this.close()
        }
      });
    }
  },
  mounted() {
  },
}
</script>
